/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FeatureFlag {
    MAKE_ORGANIZATION_VISIBLE = 'make_organization_visible',
    MAKE_PUBLIC = 'make_public',
    MEMBER_EXTERNAL_SHARING = 'member_external_sharing',
    ADMIN_EXTERNAL_SHARING = 'admin_external_sharing',
    SHOW_CONDO_FILTER = 'show_condo_filter',
}
